import axios from "axios";

/**
 * Resolve the backend base URL.
 *
 * Hard rule for cookie auth: the backend MUST be reachable on the same effective
 * origin as the page. Otherwise Safari and other browsers with strict
 * third-party-cookie policies refuse to store the `access_token` cookie, and
 * the user appears stuck on the login screen even after a 200 from /auth/login.
 *
 * - On the production hosts we own (teamfit.dk + www.teamfit.dk + app.teamfit.dk)
 *   the Emergent ingress already routes `/api/*` to the backend on the same
 *   origin (verified). Prefer `window.location.origin` there so cookies are
 *   first-party.
 * - Everywhere else (preview / localhost / Emergent preview URL) fall back to
 *   the build-time env var REACT_APP_BACKEND_URL.
 */
function resolveBackendUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const SAME_ORIGIN_HOSTS = ["teamfit.dk", "www.teamfit.dk", "app.teamfit.dk"];
    if (SAME_ORIGIN_HOSTS.includes(host)) {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true, // PRIMARY auth path — httpOnly cookie set by /api/auth/login
});

// Attach token from localStorage as a deliberate fallback when the httpOnly
// cookie can't reach the backend (e.g., the WebSocket auth `?token=` query
// param the chat & live-location channels use, and cross-origin bearer
// calls during automation). The cookie remains the canonical authority
// server-side; this header is only consulted when no cookie is present.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tf_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const WS_BASE = BACKEND_URL.replace(/^http/, "ws");
